import React, {useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from "../i18n";
import { useForm, FormProvider } from 'react-hook-form';
import Step0PersonalInfo from './formSteps/non_company_form_steps/Step0PersonalInfo';
import Step1Finalisation from './formSteps/non_company_form_steps/Step1Finalisation';
import { setFormField, addFiles, removeFile } from '../store/reducers/registrationSlice';
import {endpoints} from "../servics/apiEndpoints";

const steps = [
  'Informations personnelles',
  'Finalisation'
];

const NonCompanyFormSteps = ({ formFields, files, onFinalSubmit}) => {
  const dispatch = useDispatch();
  const language_code = useSelector(state => state.lang);
  const iso2 = useSelector((s) => s.country.country?.label) || 'togo';
  const countryCode = iso2.toLowerCase();

  const methods = useForm({
    defaultValues: {
      firstName: formFields.firstName || '',
      lastName: formFields.lastName || '',
      email: formFields.email || '',
      telephone: formFields.telephone || '',
      isCooperator: formFields.isCooperator || '',
        // Champs invisibles
        gender:'not defined',
        isRegular: true,
        platformSource: /Mobile|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'web',
        ipAddress: '',
        residenceCity: '',
        residenceCountry: '',
        activityCountry: '',
    },
    mode: 'onChange', // met à jour isValid en temps réel
    reValidateMode: 'onChange'
  });

  const { formState: { isValid }, handleSubmit } = methods;

  const [currentStep, setCurrentStep] = useState(0);

  const handleNext = () => setCurrentStep(prev => Math.min(prev + 1, steps.length - 1));
  const handleBack = () => setCurrentStep(prev => Math.max(prev - 1, 0));

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return (
          <Step0PersonalInfo
            dispatch={dispatch}
            formFields={formFields}
            language_code={language_code}
            translate={translate}
            fields={[
            'firstName',
            'lastName',
            'telephone',
            'email',
            'isCooperator'
          ]}
          />
        );
      case 1:
        return (
          <Step1Finalisation
            dispatch={dispatch}
            formFields={formFields}
            files={files}
            language_code={language_code}
            translate={translate}
            countryCode={countryCode}
            handleFileChange={e => {
              const valid = Array.from(e.target.files).filter(f =>
                ['application/pdf','image/jpeg','image/png','image/jpg'].includes(f.type)
              );
              dispatch(addFiles(valid));
            }}
            handleRemoveFile={fname => dispatch(removeFile(fname))}
            fields={[
              'isProducer',
              'isSpeculator',
              'isTrader',
              'isWorker',
              'wishesWhenRegistering'
            ]}
          />
        );
      default:
        return null;
    }
  };

    useEffect(() => {
        const fetchGeoInfo = async () => {
            try {
                // const res = await fetch('https://ipapi.co/json/');
                // const res = await fetch('https://ipinfo.io/json?token=ae76313b250558');
                const res = await fetch(endpoints.geoInfo);
                const data = await res.json();
                // console.log("📍 Données géo récupérées :", data);
                methods.setValue('gender', 'not defined');
                methods.setValue('isRegular', true);
                methods.setValue('ipAddress', data.ip || '', { shouldValidate: true });
                methods.setValue('residenceCountry', data.country || '', { shouldValidate: true });
                methods.setValue('activityCountry', countryCode || '', { shouldValidate: true });
                methods.setValue('platformSource', /Mobile|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'web', { shouldValidate: true });

                dispatch(setFormField({ field: 'gender', value: 'not defined'}));
                dispatch(setFormField({ field: 'isregular', value: true }));
                dispatch(setFormField({ field: 'ipAddress', value: data.ip || '' }));
                dispatch(setFormField({ field: 'residenceCountry', value: data.country || '' }));
                dispatch(setFormField({ field: 'activityCountry', value: countryCode || '' }));
                dispatch(setFormField({ field: 'residenceCity', value: data.city || '' }));
                dispatch(setFormField({ field: 'platformSource', value: /Mobile|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'web' }));

            } catch (error) {
                console.error('❌ Erreur de géolocalisation IP :', error);
            }
        };

        fetchGeoInfo();
    }, []);

  return (
    <FormProvider {...methods}>
        <h4>{steps[currentStep]}</h4>
        {renderStep()}
        
        <div className="step-controls d-flex gap-10 mt-3">
          {currentStep > 0 && (
            <button type="button" className="btn btn-secondary" onClick={handleBack}>
              {translate('button', language_code.lang).back_step_button}
            </button>
          )}

          {currentStep < steps.length - 1 && (
            <button
              type="button"
              className="btn btn-primary"
              disabled={!isValid}
              onClick={handleNext}
            >
              {translate('button', language_code.lang).next_step_button}
            </button>
          )}

          {currentStep === steps.length - 1 && (
            <button type="submit"
                    className="btn btn-success"
                    disabled={!isValid}
                    onClick={handleSubmit(onFinalSubmit)} // Appel parent
            >
              {translate('button', language_code.lang).submit_button}
            </button>
          )}
        </div>
    </FormProvider>
  );
};
export default NonCompanyFormSteps;
